<script setup lang="ts">
import { LuvIcon } from "@polargold/luv-ui-library";

</script>

<template>
    <div
        class="flex flex-col items-center justify-center gap-module-sm">
        <div class="w-full max-w-100 flex justify-center">

            <LuvIcon
                icon-name="fa-solid fa-triangle-exclamation"
                icon-size="fa-8x"
                icon-color="text-luv-secondary"
            />
        </div>

        <div class="flex flex-col items-center gap-text-md">
            <div>
                <slot name="headline"/>
            </div>

            <div class="mb-text-md">
                <slot name="subHeadline"/>
            </div>

            <div>
                <slot name="action"/>
            </div>
        </div>
    </div>
</template>